// Export an enum of form field modes (to it can be used in .ts component files).
export enum FormFieldMode {
    DESIGN = 'design',
    PREVIEW = 'preview',
    INSTANCE = 'instance'
}
